
/*
 * BILMEDIE - SNESOKKER STØRRELSESFINDER
 * Halo Shopify - automatisk variantvalg
 *
 * Finder størrelse ud fra dækdimension og
 * vælger den tilsvarende variant i Halo.
 *
 * Ingen automatisk tilføjelse til kurven.
 */

(function () {
  "use strict";

  if (window.BilmedieSnowSockFinderLoaded) return;
  window.BilmedieSnowSockFinderLoaded = true;

  const translations = {
    da: {
      recommended: "Vi anbefaler størrelse",
      selected: "Størrelsen er valgt automatisk.",
      unavailable: "Den anbefalede størrelse er desværre udsolgt.",
      missing: "Størrelsen findes ikke som en produktvariant.",
      noMatch: "Vi kunne ikke finde din dækdimension.",
      multiple: "Flere størrelser matcher:",
      error: "Størrelsesfinderen kunne ikke indlæses.",
      selectError: "Vælg venligst størrelsen manuelt nedenfor."
    },
    sv: {
      recommended: "Vi rekommenderar storlek",
      selected: "Storleken har valts automatiskt.",
      unavailable: "Den rekommenderade storleken är slutsåld.",
      missing: "Storleken finns inte som produktvariant.",
      noMatch: "Vi kunde inte hitta din däckdimension.",
      multiple: "Flera storlekar matchar:",
      error: "Storleksguiden kunde inte laddas.",
      selectError: "Välj storleken manuellt nedan."
    },
    nl: {
      recommended: "Wij adviseren maat",
      selected: "De maat is automatisch geselecteerd.",
      unavailable: "De aanbevolen maat is helaas uitverkocht.",
      missing: "Deze maat is niet beschikbaar als productvariant.",
      noMatch: "We konden uw bandenmaat niet vinden.",
      multiple: "Meerdere maten komen overeen:",
      error: "De maatzoeker kon niet worden geladen.",
      selectError: "Selecteer de maat hieronder handmatig."
    },
    fr: {
      recommended: "Nous recommandons la taille",
      selected: "La taille a été sélectionnée automatiquement.",
      unavailable: "La taille recommandée est épuisée.",
      missing: "Cette taille n'existe pas comme variante.",
      noMatch: "Cette dimension de pneu est introuvable.",
      multiple: "Plusieurs tailles correspondent :",
      error: "Le guide des tailles n'a pas pu être chargé.",
      selectError: "Sélectionnez la taille manuellement ci-dessous."
    }
  };

  const lang = (document.documentElement.lang || "da")
    .toLowerCase()
    .split("-")[0];

  const t = translations[lang] || translations.da;

  function normalize(value) {
    return String(value || "")
      .toUpperCase()
      .replace(/\s+/g, "");
  }

  function sortNumeric(a, b) {
    return parseFloat(a) - parseFloat(b);
  }

  function makeOption(value) {
    const option = document.createElement("option");
    option.value = value;
    option.textContent = value;
    return option;
  }

  function resetSelect(select) {
    select.replaceChildren(makeOption(""));
    select.disabled = true;
  }

  function showResult(root, message, success) {
    const result = root.querySelector("[data-sf-result]");

    if (!result) return;

    result.hidden = false;
    result.replaceChildren();

    const heading = document.createElement("div");
    heading.textContent = (success ? "✓ " : "") + message;
    heading.style.fontWeight = "700";
    heading.style.fontSize = success ? "18px" : "14px";
    heading.style.color = success ? "#16803c" : "#92400e";
    heading.style.lineHeight = "1.5";

    result.appendChild(heading);
  }

  function findVariantPicker(root) {
    const productId = root.dataset.productId;

    // Find produktets egen Halo-variantvælger.
    const pickers = [
      ...document.querySelectorAll(
        ".productView-variants variant-radios, " +
        ".productView-variants variant-selects"
      )
    ];

    // Hvis product-id er tilgængeligt, brug det.
    if (productId) {
      const exact = pickers.find(
        picker => picker.dataset.product === productId
      );

      if (exact) return exact;
    }

    // Foretræk variantvælgeren i samme produktområde.
    const productArea = root.closest(".productView");

    if (productArea) {
      const local = productArea.querySelector(
        ".productView-variants variant-radios, " +
        ".productView-variants variant-selects"
      );

      if (local) return local;
    }

    // Undgå at vælge en variant på et forkert produkt.
    return pickers.length === 1 ? pickers[0] : null;
  }

  function chooseHaloVariant(root, variant, size) {
    const picker = findVariantPicker(root);

    if (!picker) return false;

    const wanted = normalize(size);

    // HALO - KNAPPER / RADIO
    if (picker.tagName.toLowerCase() === "variant-radios") {
      const fieldsets = [
        ...picker.querySelectorAll("fieldset")
      ];

      for (const fieldset of fieldsets) {
        const radio = [
          ...fieldset.querySelectorAll('input[type="radio"]')
        ].find(input => normalize(input.value) === wanted);

        if (!radio) continue;

        // Klik på den faktiske Halo-radio.
        // Det aktiverer temaets egne event listeners.
        if (!radio.checked) {
          radio.click();
        } else {
          radio.dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }

        return radio.checked;
      }

      return false;
    }

    // HALO - DROPDOWN
    if (picker.tagName.toLowerCase() === "variant-selects") {
      const selects = [
        ...picker.querySelectorAll("select")
      ];

      for (const select of selects) {
        const option = [...select.options].find(
          item => normalize(item.value) === wanted
        );

        if (!option) continue;

        select.value = option.value;

        select.dispatchEvent(
          new Event("change", { bubbles: true })
        );

        return normalize(select.value) === wanted;
      }
    }

    return false;
  }

  function getVariants(root) {
    const script = root.querySelector("[data-sf-variants]");

    if (!script) return [];

    try {
      const variants = JSON.parse(script.textContent || "[]");
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      console.error("Bilmedie: Ugyldige variantdata", error);
      return [];
    }
  }

  function findMatchingVariants(variants, size) {
    const wanted = normalize(size);

    return variants.filter(variant =>
      [variant.option1, variant.option2, variant.option3]
        .some(option => normalize(option) === wanted)
    );
  }

  function init(root) {
    if (root.dataset.ready === "1") return;
    root.dataset.ready = "1";

    const width = root.querySelector("[data-sf-width]");
    const profile = root.querySelector("[data-sf-profile]");
    const rim = root.querySelector("[data-sf-rim]");
    const button = root.querySelector("[data-sf-search]");
    const result = root.querySelector("[data-sf-result]");

    if (!width || !profile || !rim || !button || !result) {
      return;
    }

    fetch(root.dataset.dataUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error("Størrelsesdata kunne ikke hentes");
        }
        return response.json();
      })
      .then(allData => {
        const sizes = allData[root.dataset.handle];

        if (!sizes) {
          throw new Error(
            "Ingen størrelsesdata for: " + root.dataset.handle
          );
        }

        const lookup = new Map();
        const profiles = new Map();
        const rims = new Map();

        Object.entries(sizes).forEach(([size, tires]) => {
          if (!Array.isArray(tires)) return;

          tires.forEach(tire => {
            const match = normalize(tire).match(
              /^(\d{3})\/(\d{2,3})R(\d{2}(?:\.5)?)$/
            );

            if (!match) return;

            const [, w, p, r] = match;
            const key = `${w}/${p}R${r}`;

            if (!lookup.has(key)) {
              lookup.set(key, []);
            }

            if (!lookup.get(key).includes(size)) {
              lookup.get(key).push(size);
            }

            if (!profiles.has(w)) {
              profiles.set(w, new Set());
            }

            profiles.get(w).add(p);

            const wp = `${w}/${p}`;

            if (!rims.has(wp)) {
              rims.set(wp, new Set());
            }

            rims.get(wp).add(r);
          });
        });

        [...profiles.keys()]
          .sort(sortNumeric)
          .forEach(value => {
            width.appendChild(makeOption(value));
          });

        width.addEventListener("change", () => {
          resetSelect(profile);
          resetSelect(rim);
          button.disabled = true;
          result.hidden = true;

          if (!width.value) return;

          [...(profiles.get(width.value) || [])]
            .sort(sortNumeric)
            .forEach(value => {
              profile.appendChild(makeOption(value));
            });

          profile.disabled = false;
        });

        profile.addEventListener("change", () => {
          resetSelect(rim);
          button.disabled = true;
          result.hidden = true;

          if (!profile.value) return;

          const key = `${width.value}/${profile.value}`;

          [...(rims.get(key) || [])]
            .sort(sortNumeric)
            .forEach(value => {
              rim.appendChild(makeOption(value));
            });

          rim.disabled = false;
        });

        rim.addEventListener("change", () => {
          button.disabled = !rim.value;
          result.hidden = true;
        });

        button.addEventListener("click", () => {
          if (!width.value || !profile.value || !rim.value) {
            return;
          }

          const key =
            `${width.value}/${profile.value}R${rim.value}`;

          const matches = lookup.get(key) || [];

          if (!matches.length) {
            showResult(root, t.noMatch, false);
            return;
          }

          if (matches.length !== 1) {
            showResult(
              root,
              `${t.multiple} ${matches.join(", ")}`,
              false
            );
            return;
          }

          const size = matches[0];
          const variants = getVariants(root);
          const matchingVariants = findMatchingVariants(
            variants,
            size
          );

          if (matchingVariants.length !== 1) {
            showResult(root, t.missing, false);
            return;
          }

          const variant = matchingVariants[0];

          if (!variant.available) {
            showResult(
              root,
              `${t.recommended} ${size}. ${t.unavailable}`,
              false
            );
            return;
          }

          const selected = chooseHaloVariant(
            root,
            variant,
            size
          );

          if (!selected) {
            showResult(
              root,
              `${t.recommended} ${size}. ${t.selectError}`,
              false
            );
            return;
          }

          // Ingen ekstra tekst under anbefalingen.
          showResult(
            root,
            `${t.recommended} ${size}`,
            true
          );
        });
      })
      .catch(error => {
        console.error(
          "[Bilmedie Snesokker Finder]",
          error
        );

        showResult(root, t.error, false);
      });
  }

  function boot() {
    document
      .querySelectorAll("[data-snesok-finder]")
      .forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
